import styled from 'styled-components';

import { colors } from '../../Pages/Sindico/colors';

export const StyledFile = styled.div`
  padding: 16px 25px 16px 25px;

  max-width: 100%;
  height: 56px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  background-color: transparent;
  transition: 0.3s;
  height: 80px;
  border: none;
  border-bottom: 1px solid ${colors.gray[300]};
  max-width: 100%;
  gap: 6px 32px;
  justify-content: space-between;
  &:hover {
    background-color: ${colors.gray[100]};
  }

  .folder-name {
    font-weight: normal;
  }

  .icon {
    background-color: #f7f8fa;
    border-radius: 50%;
    box-sizing: border-box;
    min-width: 48px;
    min-height: 48px;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: ${({ $hasUrl }) => $hasUrl && 'pointer'};
  }

  .file-name {
    font-size: 16px;
    word-break: break-word;
    color: ${colors.gray[700]};
    font-weight: normal;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    border: none;
    padding: 0;
    background-color: transparent;
    text-align: left;
    width: 100%;
    align-items: center;
    box-sizing: border-box;
    cursor: ${({ $hasUrl }) => $hasUrl && 'pointer'};
    &:hover {
      color: ${({ $hasUrl }) => $hasUrl && colors.primary};
    }
  }

  .container-infos-actions {
    display: flex;
    gap: 8px;

    .upload-status-file {
      color: ${colors.gray[600]};
      font-size: 14px;
      width: max-content;
    }

    .file-actions {
      button {
        background-color: transparent;
        border: none;
        cursor: pointer;
        color: ${colors.primary};
        font-size: 14px;
        width: 120px;
        text-align: right;

        &:not(:disabled):hover {
          font-weight: 500;
        }

        &:disabled {
          color: ${colors.gray[450]};
        }
      }
    }
  }

  @media (max-width: 1024px) {
    display: grid;
    gap: 6px 16px;
    padding: 16px 8px 16px 8px;
    width: 100%;
    justify-content: start;

    .icon {
      grid-area: icon;
    }

    .file-name {
      grid-area: file-name;
    }

    .container-infos-actions {
      grid-area: container-infos-actions;
    }

    grid-template-areas:
      'icon file-name'
      'icon container-infos-actions';
  }
`;
